// Componente per sistema ExeDialog DDT2026 - Step cod_bolla, num_bolla, data_bolla
// Qui l'utente sceglie anche la modalita' di lavoro (coupon o DDT): la scelta
// iniziale configura dinamicamente le pagine successive (SPECCOUPON2026.md).
import React, { useState, useRef, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { SelectButton } from 'primereact/selectbutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { usePesiPonte } from '../queries';
import { isCouponMode } from '../couponMode';
import { WebCam } from './WebCam';
import { ValoriVerificati } from './ValoriVerificati';

// Azioni possibili: il coupon e' l'azione di default
const AZIONI = [
    { label: 'Coupon di carico', value: true },
    { label: 'Emissione DDT', value: false }
];

export function CodBolla(props) {
    const { currURLSearchParams, onFinish, onUpdateParams, verificaData } = props;
    const inputRef = useRef();

    const opzioni = verificaData?.opzioni_selezione || [];

    const [state, setState] = useState({
        cod_bolla: currURLSearchParams.get('cod_bolla') || opzioni[0]?.cod_bolla || '',
        num_bolla: currURLSearchParams.get('num_bolla') ? parseInt(currURLSearchParams.get('num_bolla'), 10) : null,
        data_bolla: currURLSearchParams.get('data_bolla') || ''
    });

    // La modalita' vive nell'URL, non nello stato locale: la scelta configura
    // le pagine successive e il titolo della scheda, che la leggono da li'.
    const modalitaCoupon = isCouponMode(currURLSearchParams);

    // Polling pesi dalla pesa per il cod_bolla selezionato
    const selectedOption = opzioni.find(o => o.cod_bolla === state.cod_bolla);
    const ddtMetadati = selectedOption?.ddt || {};
    const codBollaPesa = ddtMetadati.pesa || state.cod_bolla || null;
    const { pesi } = usePesiPonte(codBollaPesa);

    // camUrl dell'opzione selezionata (dipende dal codice bolla)
    const camUrl = ddtMetadati.camUrl || null;

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [verificaData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (state.cod_bolla) {
            onFinish({
                modalita_coupon: modalitaCoupon,
                cod_bolla: state.cod_bolla,
                // Nel coupon numero e data della bolla sono dati dinamici,
                // assegnati all'emissione del DDT: restano nulli
                num_bolla: modalitaCoupon ? null : state.num_bolla,
                data_bolla: modalitaCoupon ? null : (state.data_bolla || null)
            });
        }
    };

    // Template per dropdown che mostra cod_bolla - descrizione
    const optionTemplate = (option) => {
        return <span>{option.cod_bolla} - {option.descrizione}</span>;
    };

    const valueTemplate = (option) => {
        if (option) {
            return <span>{option.cod_bolla} - {option.descrizione}</span>;
        }
        return <span>Seleziona codice bolla</span>;
    };

    // Pesi dalla pesa convertiti per la tabella
    const pesiTabella = pesi.map(p => ({
        ...p,
        pesoTonnellate: (p.peso / 10).toFixed(2),
        ora: new Date(p.data).toLocaleTimeString()
    }));

    return (
        <div className="card-body">
            <h5 className="card-title">Codice Bolla</h5>
            <p className="text-muted">
                {modalitaCoupon
                    ? 'Selezionare l\u2019azione e il codice bolla. Il coupon registra i dati del carico: numero, data e lordo del DDT vengono assegnati all\u2019attivazione.'
                    : 'Selezionare il codice bolla e eventualmente il numero di bolla e/o la data. Impostando il numero di bolla esistente la bolla sovrascriverà la precedente.'}
            </p>

            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="modalita_coupon" className="form-label">Azione</label>
                    <div>
                        <SelectButton
                            id="modalita_coupon"
                            value={modalitaCoupon}
                            options={AZIONI}
                            onChange={(e) => e.value !== null && onUpdateParams({ modalita_coupon: e.value })}
                        />
                    </div>
                </div>

                <div className="mb-3">
                    <label htmlFor="cod_bolla" className="form-label">Codice Bolla</label>
                    <Dropdown 
                        ref={inputRef}
                        id="cod_bolla"
                        value={selectedOption}
                        options={opzioni} 
                        onChange={(e) => setState({...state, cod_bolla: e.value?.cod_bolla || ''})}
                        optionLabel="cod_bolla"
                        itemTemplate={optionTemplate}
                        valueTemplate={valueTemplate}
                        placeholder="Seleziona codice bolla"
                        className="w-100"
                    />
                </div>

                {!modalitaCoupon && (
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label htmlFor="num_bolla" className="form-label">Numero Bolla (opzionale)</label>
                        <InputNumber 
                            id="num_bolla"
                            value={state.num_bolla}
                            onValueChange={(e) => setState({...state, num_bolla: e.value})}
                            className="w-100"
                            useGrouping={false}
                        />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="data_bolla" className="form-label">Data (opzionale)</label>
                        <input 
                            type="datetime-local"
                            id="data_bolla"
                            value={state.data_bolla}
                            onChange={(e) => setState({...state, data_bolla: e.target.value})}
                            className="form-control"
                        />
                    </div>
                </div>
                )}

                <button className="btn btn-primary" disabled={!state.cod_bolla}>
                    Prosegui
                </button>

                {pesiTabella.length > 0 && (
                    <div className="card mt-3 mb-3">
                        <DataTable 
                            value={pesiTabella} 
                            size="small"
                            scrollable
                            scrollHeight="400px"
                            header="Pesi rilevati dalla pesa"
                        >
                            <Column field="pesoTonnellate" header="Peso (q.li)" style={{ width: '50%' }} sortable />
                            <Column field="ora" header="Ora" style={{ width: '50%' }} sortable />
                        </DataTable>
                    </div>
                )}

                <WebCam verificaData={verificaData} target="targa" camUrl={camUrl} />
                <WebCam verificaData={verificaData} target="cassone" camUrl={camUrl} />
            </form>
            
            <ValoriVerificati valori={verificaData?.valori_verificati} />
        </div>
    );
}

CodBolla.displayName = 'cod_bolla';
